import styled from "styled-components";

export const ParentContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
`;

export const MainContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
